import { registerWebModule, NativeModule } from "expo";

class ExpoScreenshotModule extends NativeModule {}

export default registerWebModule(ExpoScreenshotModule, "ExpoScreenshotModule");
